import { render, staticRenderFns } from "./SalaryCreate.vue?vue&type=template&id=1f1b4917"
import script from "../../controllers/salary/salary-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/salary/salary-create.js?vue&type=script&lang=js&external"
import style0 from "./SalaryCreate.vue?vue&type=style&index=0&id=1f1b4917&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports